import { AppOfflineService } from '~/sqlite/services/app';
import {
  IssueCategory,
  IssueSortingType,
  Label,
} from '~/types';
import { issueLocal } from './IssueLocalDataSource';

export class AppReferenceLocalDataSource extends AppOfflineService {
  resetIssueCategories(data: IssueCategory[]): Promise<void> {
    return issueLocal.resetIssueCategories(data);
  }

  getAllIssueCategories(): Promise<IssueCategory[]> {
    return issueLocal.getAllIssueCategories();
  }

  resetIssueSortingTypes(data: IssueSortingType[]): Promise<void> {
    return issueLocal.resetIssueSortingTypes(data);
  }

  getAllIssueSortingTypes(): Promise<IssueSortingType[]> {
    return issueLocal.getAllIssueSortingTypes();
  }

  resetIssueLabels(data: Label[]): Promise<void> {
    return issueLocal.resetIssueLabels(data);
  }

  getAllIssueLabels(): Promise<Label[]> {
    return issueLocal.getAllIssueLabels();
  }
}

export const appReferenceLocal = new AppReferenceLocalDataSource();
